// GridironIQ — Player Data
// Data structure separates staff-facing and media-facing fields intentionally.
// Staff view: measurables, production, PFF grades, snap counts, contact
// Media view: recruiting rankings, platform commentary, narrative context

export const PLAYERS = [

  // ─── DJ LAGWAY ────────────────────────────────────────────────────────────
  {
    id: 1,
    name: "DJ Lagway",
    pos: "QB",
    number: 2,
    portalStatus: "Enrolled",
    destination: "Baylor",
    prev: "Florida",
    season: "2025",
    rating: 92,
    delta: +1.4,
    eligibility: "2 yrs",

    // Staff-facing: measurables
    measurables: {
      height: "6'2\"",
      weight: "215",
      armLength: null,
      wingspan: null,
      hometown: "Willis, TX",
      highSchool: "Willis High School",
      draftProjection: "1st Round (2027)",
    },

    // Staff-facing: production
    production: {
      season: "2025",
      completions: 213,
      attempts: 337,
      compPct: 63.2,
      yards: 2264,
      tds: 16,
      ints: 14,
      rushAtt: 62,
      rushYards: 136,
      rushTDs: 1,
      snapCount: 542,
      pffGrade: 71.4,
      pffPassGrade: 69.8,
      pressuredCompPct: 48.2,
      cleanPocketCompPct: 74.1,
      twoyearYards: 4179,
      twoyearTDs: 28,
      twoyearINTs: 23,
    },

    weeklyStats: [
      { week: "Wk 5", yards: 287, tds: 1, ints: 5 },
      { week: "Wk 7", yards: 241, tds: 2, ints: 1 },
      { week: "Wk 9", yards: 298, tds: 2, ints: 0 },
      { week: "Wk 11", yards: 204, tds: 1, ints: 2 },
      { week: "Wk 12", yards: 312, tds: 3, ints: 0 },
      { week: "Wk 13", yards: 276, tds: 3, ints: 0 },
    ],

    radar: [
      { stat: "Arm Strength", val: 94 },
      { stat: "Accuracy", val: 78 },
      { stat: "Mobility", val: 82 },
      { stat: "Decision", val: 71 },
      { stat: "Leadership", val: 85 },
      { stat: "Football IQ", val: 83 },
    ],

    // Staff-facing: contact
    contact: {
      agent: "Undisclosed",
      agency: "Undisclosed",
      agentPhone: null,
      agentEmail: null,
      note: "Represented — contact via Baylor football ops",
    },

    // Media-facing: recruiting
    recruiting: {
      classYear: 2024,
      stars247: 5,
      starsRivals: 5,
      starsESPN: 5,
      nationalRank247: 3,
      posRank247: 1,
      stateRank: 1,
      state: "TX",
      commitSchool: "Florida",
      otherOffers: ["Georgia", "Alabama", "LSU", "Ohio State", "Texas"],
      platformCommentary: {
        source: "247Sports / On3",
        text: "Elite dual-threat profile with rare arm talent and plus athleticism. Inconsistency under pressure and a team-high 14 interceptions in 2025 tempered expectations, but ceiling remains legitimate first-round territory. Two years of eligibility make him one of the most coveted portal QBs in recent memory.",
      },
    },
  },

  // ─── SAM LEAVITT ──────────────────────────────────────────────────────────
  {
    id: 2,
    name: "Sam Leavitt",
    pos: "QB",
    number: 10,
    portalStatus: "Enrolled",
    destination: "LSU",
    prev: "Arizona State",
    season: "2025",
    rating: 88,
    delta: -2.1,
    eligibility: "2 yrs",
    careerHistory: [
      { years: "2023", school: "Michigan State", role: "Transfer Entry", note: "Entered portal after 2022 season · 1 year at MSU" },
      { years: "2023–25", school: "Arizona State", role: "Transfer Entry", note: "Entered portal after 2025 season · 88.5 grade (2024)" },
    ],

    measurables: {
      height: "6'2\"",
      weight: "210",
      armLength: null,
      wingspan: null,
      hometown: "Bellevue, WA",
      highSchool: "Eastside Catholic School",
      draftProjection: "2nd–3rd Round (2027)",
    },

    production: {
      season: "2025",
      completions: null,
      attempts: null,
      compPct: null,
      yards: null,
      tds: null,
      ints: null,
      rushAtt: null,
      rushYards: null,
      rushTDs: null,
      snapCount: null,
      pffGrade: 74.6,
      pffGrade2024: 88.5,
      note: "Season-ending Lisfranc injury in late October 2025. Full recovery expected by spring 2026.",
      priorSeasonYards: 3233,
      priorSeasonTDs: 24,
      priorSeasonINTs: 8,
      priorSeasonCompPct: 65.1,
      careerRecord: "16-4",
    },

    weeklyStats: [
      { week: "Wk 1", yards: 312, tds: 3, ints: 0 },
      { week: "Wk 2", yards: 278, tds: 2, ints: 1 },
      { week: "Wk 3", yards: 241, tds: 1, ints: 0 },
      { week: "Wk 4", yards: 198, tds: 2, ints: 2 },
      { week: "Wk 5", yards: 167, tds: 1, ints: 1 },
      { week: "Wk 6", yards: 143, tds: 1, ints: 0 },
    ],

    radar: [
      { stat: "Arm Strength", val: 84 },
      { stat: "Accuracy", val: 86 },
      { stat: "Mobility", val: 88 },
      { stat: "Decision", val: 83 },
      { stat: "Leadership", val: 90 },
      { stat: "Football IQ", val: 87 },
    ],

    contact: {
      agent: "Undisclosed",
      agency: "Undisclosed",
      agentPhone: null,
      agentEmail: null,
      note: "Enrolled at LSU. Contact via LSU football ops.",
    },

    recruiting: {
      classYear: 2023,
      stars247: 4,
      starsRivals: 4,
      starsESPN: 4,
      nationalRank247: null,
      posRank247: null,
      stateRank: null,
      state: "WA",
      commitSchool: "Michigan State",
      otherOffers: ["Washington", "Oregon", "Utah", "Arizona State"],
      platformCommentary: {
        source: "PFF / On3",
        text: "Elite PFF grade in 2024 (88.5) followed by injury-shortened 2025 (74.6) raises durability questions. 16-4 career record as a starter demonstrates winning pedigree. Creative playmaker with plus mobility who elevates around him. LSU represents his third program — durability and health will be scrutinized heavily.",
      },
    },
  },

  // ─── DYLAN RAIOLA ─────────────────────────────────────────────────────────
  {
    id: 3,
    name: "Dylan Raiola",
    pos: "QB",
    number: 15,
    portalStatus: "Enrolled",
    destination: "Oregon",
    prev: "Nebraska",
    season: "2025",
    rating: 87,
    delta: +0.8,
    eligibility: "3 yrs",

    measurables: {
      height: "6'3\"",
      weight: "220",
      armLength: null,
      wingspan: null,
      hometown: "Buford, GA",
      highSchool: "Buford High School",
      draftProjection: "2nd Round (2028)",
    },

    production: {
      season: "2025",
      completions: null,
      attempts: null,
      compPct: null,
      yards: null,
      tds: null,
      ints: null,
      snapCount: null,
      pffGrade: null,
      note: "Broken fibula in early November 2025. Full recovery expected.",
      twoyearYards: 4819,
      twoyearTDs: 31,
      twoyearINTs: 17,
      twoyearGames: 22,
    },

    weeklyStats: [
      { week: "Wk 2", yards: 348, tds: 3, ints: 0 },
      { week: "Wk 3", yards: 291, tds: 2, ints: 1 },
      { week: "Wk 5", yards: 412, tds: 4, ints: 0 },
      { week: "Wk 6", yards: 267, tds: 1, ints: 2 },
      { week: "Wk 7", yards: 308, tds: 2, ints: 1 },
      { week: "Wk 8", yards: 224, tds: 1, ints: 0 },
    ],

    radar: [
      { stat: "Arm Strength", val: 92 },
      { stat: "Accuracy", val: 83 },
      { stat: "Mobility", val: 68 },
      { stat: "Decision", val: 80 },
      { stat: "Leadership", val: 88 },
      { stat: "Football IQ", val: 86 },
    ],

    contact: {
      agent: "Undisclosed",
      agency: "Undisclosed",
      agentPhone: null,
      agentEmail: null,
      note: "Enrolled at Oregon. Contact via Oregon football ops.",
    },

    recruiting: {
      classYear: 2024,
      stars247: 5,
      starsRivals: 5,
      starsESPN: 5,
      nationalRank247: 1,
      posRank247: 1,
      stateRank: 1,
      state: "GA",
      commitSchool: "Nebraska",
      otherOffers: ["Georgia", "Ohio State", "Alabama", "Notre Dame", "USC"],
      platformCommentary: {
        source: "247Sports / ESPN",
        text: "Former No. 1 overall recruit in the class of 2024 with a lengthy Georgia commit before a late flip to Nebraska. Pro-style pocket passer with top-tier arm talent. Two-year production at Nebraska (4,819 yards, 31 TDs) shows steady development. Broken fibula late 2025 is primary health concern entering Oregon.",
      },
    },
  },

  // ─── JORDAN SEATON ────────────────────────────────────────────────────────
  {
    id: 4,
    name: "Jordan Seaton",
    pos: "OT",
    number: 77,
    portalStatus: "Enrolled",
    destination: "LSU",
    prev: "Colorado",
    season: "2025",
    rating: 95,
    delta: +1.2,
    eligibility: "2 yrs",

    measurables: {
      height: "6'5\"",
      weight: "287",
      armLength: "33 3/8\"",
      wingspan: "6'10\"",
      hometown: "Washington, D.C.",
      highSchool: "IMG Academy (Bradenton, FL)",
      draftProjection: "Top-10 Pick (2027)",
    },

    production: {
      season: "2025",
      snapCount: 541,
      sacksAllowed: 1,
      qbHitsAllowed: 0,
      pressuresAllowed: 5,
      pffPassBlockGrade: null,
      note: "Missed final 3 games of 2025 due to injury. Rated 11th best pass blocker in Big 12, 2nd best OT.",
      season2024SnapCount: 612,
      season2024SacksAllowed: 2,
      season2024PffGrade: 75.3,
      season2024Note: "Highest graded true freshman OT in pass protection (min. 100 snaps) per PFF.",
      careerSacksAllowed: 3,
      careerSnaps: 1153,
    },

    weeklyStats: [
      { week: "Wk 1", sacksAllowed: 0, pressures: 1 },
      { week: "Wk 2", sacksAllowed: 0, pressures: 0 },
      { week: "Wk 3", sacksAllowed: 0, pressures: 1 },
      { week: "Wk 4", sacksAllowed: 1, pressures: 1 },
      { week: "Wk 5", sacksAllowed: 0, pressures: 2 },
      { week: "Wk 6", sacksAllowed: 0, pressures: 0 },
    ],

    radar: [
      { stat: "Pass Pro", val: 94 },
      { stat: "Run Block", val: 88 },
      { stat: "Footwork", val: 93 },
      { stat: "Anchor", val: 90 },
      { stat: "Athleticism", val: 92 },
      { stat: "Finish", val: 91 },
    ],

    contact: {
      agent: "Undisclosed",
      agency: "Undisclosed",
      agentPhone: null,
      agentEmail: null,
      note: "Enrolled at LSU. Contact via LSU football ops.",
    },

    recruiting: {
      classYear: 2024,
      stars247: 5,
      starsRivals: 5,
      starsESPN: 5,
      nationalRank247: 13,
      posRank247: 1,
      stateRank: 4,
      state: "FL",
      commitSchool: "Colorado",
      otherOffers: ["Ohio State", "Georgia", "Alabama", "Clemson", "Tennessee", "Auburn"],
      platformCommentary: {
        source: "247Sports / On3",
        text: "Consensus #1 OT in the 2024 class. Commitment to Colorado under Deion Sanders was widely considered one of the most shocking recruiting decisions in recent memory. Athletically-gifted with rare lateral quickness for his size. Clocked 17.7 MPH on GPS while pulling in a game. Immediate plug-and-play left tackle at any program.",
      },
    },
  },

  // ─── JOHN HENRY DALEY ─────────────────────────────────────────────────────
  {
    id: 5,
    name: "John Henry Daley",
    pos: "EDGE",
    number: 91,
    portalStatus: "Enrolled",
    destination: "Michigan",
    prev: "Utah",
    season: "2025",
    rating: 94,
    delta: +3.1,
    eligibility: "2 yrs",
    careerHistory: [
      { years: "2021–22", school: "BYU", role: "Transfer Entry", note: "Entered portal after 2022 season · 2 years at BYU" },
      { years: "2023–25", school: "Utah", role: "Transfer Entry", note: "Entered portal after 2025 season · 92.5 grade (2025)" },
    ],

    measurables: {
      height: "6'4\"",
      weight: "255",
      armLength: null,
      wingspan: null,
      hometown: "American Fork, UT",
      highSchool: "Lone Peak High School",
      draftProjection: "1st–2nd Round (2027)",
      note: "Served 2-year LDS mission before playing college football. Age 24 entering 2026.",
    },

    production: {
      season: "2025",
      tackles: 48,
      tfl: 17.5,
      sacks: 11.5,
      pressures: 51,
      forcedFumbles: 2,
      passBreakups: 1,
      snapCount: 280,
      pffGrade: 92.5,
      sackYards: 91,
      note: "Tied FBS lead in TFL (17.5) at time of injury. #2 nationally in sacks. Injured vs. Kansas State in Wk 11.",
      games: 11,
    },

    weeklyStats: [
      { week: "Wk 3", sacks: 2.0, pressures: 8 },
      { week: "Wk 5", sacks: 1.5, pressures: 7 },
      { week: "Wk 7", sacks: 2.5, pressures: 9 },
      { week: "Wk 8", sacks: 1.0, pressures: 5 },
      { week: "Wk 9", sacks: 2.0, pressures: 8 },
      { week: "Wk 10", sacks: 3.5, pressures: 11 },
    ],

    radar: [
      { stat: "Pass Rush", val: 95 },
      { stat: "Run Stop", val: 86 },
      { stat: "Coverage", val: 72 },
      { stat: "Athleticism", val: 91 },
      { stat: "Motor", val: 97 },
      { stat: "Instincts", val: 90 },
    ],

    contact: {
      agent: "ESM (Elite Sports Management)",
      agency: "Elite Sports Management",
      agentPhone: null,
      agentEmail: null,
      note: "Represented by @ThisisESM per On3 reporting.",
    },

    recruiting: {
      classYear: 2021,
      stars247: 3,
      starsRivals: 3,
      starsESPN: 3,
      nationalRank247: null,
      posRank247: null,
      stateRank: null,
      state: "UT",
      commitSchool: "BYU",
      otherOffers: ["Utah", "Utah State"],
      platformCommentary: {
        source: "On3 / Walter Camp",
        text: "One of the most compelling development stories in college football. Lightly recruited out of high school, served a 2-year LDS mission, then became a first-team All-American at Utah in 2025. 92.5 PFF grade led all portal defenders. 51 pressures on just 280 pass-rush snaps. Motor and instincts test off the charts on film.",
      },
    },
  },

  // ─── PRINCEWILL UMANMIELEN ────────────────────────────────────────────────
  {
    id: 6,
    name: "Princewill Umanmielen",
    pos: "EDGE",
    number: 1,
    portalStatus: "Enrolled",
    destination: "LSU",
    prev: "Ole Miss",
    season: "2025",
    rating: 91,
    delta: +2.2,
    eligibility: "1 yr",

    measurables: {
      height: "6'5\"",
      weight: "245",
      armLength: null,
      wingspan: null,
      hometown: "Austin, TX",
      highSchool: "Manor High School",
      draftProjection: "2nd–3rd Round (2027)",
      note: "Brother Princely Umanmielen drafted 3rd round (77th overall) by Carolina Panthers in 2025.",
    },

    production: {
      season: "2025",
      tackles: 45,
      tfl: 13.0,
      sacks: 9.0,
      pressures: 19,
      forcedFumbles: 0,
      passBreakups: 2,
      interceptions: 1,
      snapCount: null,
      pffGrade: null,
      secRankSacks: 3,
      secRankTFL: 8,
      note: "Ranked #3 in SEC in sacks, #8 in TFL. Third-team All-SEC. Helped Ole Miss to 13-2 record and CFP semifinal.",
      games: 15,
      careerSacks: 10.5,
      careerTackles: 79,
    },

    weeklyStats: [
      { week: "Wk 2", sacks: 1.5, pressures: 4 },
      { week: "Wk 5", sacks: 1.0, pressures: 3 },
      { week: "Wk 7", sacks: 0.5, pressures: 2 },
      { week: "Wk 9", sacks: 1.5, pressures: 5 },
      { week: "CFP R1", sacks: 1.5, pressures: 4 },
      { week: "CFP QF", sacks: 1.0, pressures: 3 },
    ],

    radar: [
      { stat: "Pass Rush", val: 90 },
      { stat: "Run Stop", val: 84 },
      { stat: "Coverage", val: 76 },
      { stat: "Athleticism", val: 89 },
      { stat: "Motor", val: 88 },
      { stat: "Instincts", val: 86 },
    ],

    contact: {
      agent: "Undisclosed",
      agency: "Undisclosed",
      agentPhone: null,
      agentEmail: null,
      note: "Portal entry contested by Ole Miss (~$550K buyout). Now enrolled at LSU.",
    },

    recruiting: {
      classYear: 2023,
      stars247: 4,
      starsRivals: 4,
      starsESPN: 4,
      nationalRank247: null,
      posRank247: 22,
      stateRank: 40,
      state: "TX",
      commitSchool: "Nebraska",
      otherOffers: ["Arkansas", "Florida", "Washington"],
      platformCommentary: {
        source: "On3 / LSU Athletics",
        text: "Four-star out of Manor, TX who followed his brother Princely (2025 Panthers 3rd-rounder) through the college football pipeline. Breakthrough 2025 season at Ole Miss elevated his profile significantly. Stunning portal entry — Ole Miss had publicly announced his return before he reversed course on the final day of the window. LSU landed him for a reported ~$550K buyout.",
      },
    },
  },

];

export default PLAYERS;
